(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.getAttribute('data-rv-ready') === 'true') return;

    var track = root.querySelector('[data-rv-track]');
    var slides = toArray(root.querySelectorAll('[data-rv-slide]'));
    var dotsWrap = root.querySelector('[data-rv-dots]');
    var prev = root.querySelector('[data-rv-prev]');
    var next = root.querySelector('[data-rv-next]');
    var status = root.querySelector('[data-rv-status]');
    var bar = root.querySelector('[data-rv-bar]');
    if (!track || slides.length === 0) return;

    root.setAttribute('data-rv-ready', 'true');

    var delay = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var designMode = window.Shopify && window.Shopify.designMode;
    var autoplaySetting = root.getAttribute('data-autoplay') === 'true';
    var index = 0;
    var timer = null;
    var hovering = false;
    var hidden = document.hidden;
    var dots = [];
    var mqTablet = window.matchMedia('(max-width: 989px)');
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var controls = root.querySelector('.rv__controls');
    var progress = root.querySelector('.rv__progress');

    function perView() {
      if (mqMobile.matches) return 1;
      if (mqTablet.matches) return 2;
      return 3;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function updateChrome() {
      var show = maxIndex() > 0;
      if (controls) controls.hidden = !show;
      if (progress) progress.hidden = !show;
    }

    function setBar(running) {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(0)';
      if (!running) return;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          bar.style.transition = 'transform ' + delay + 'ms linear';
          bar.style.transform = 'scaleX(1)';
        });
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var pages = maxIndex() + 1;
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rv__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Show reviews group ' + (i + 1));
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        (function (page) {
          btn.addEventListener('click', function () {
            go(page);
          });
        })(i);
        dotsWrap.appendChild(btn);
        dots.push(btn);
      }
    }

    function show(nextIndex, user) {
      var max = maxIndex();
      if (nextIndex < 0) nextIndex = max;
      if (nextIndex > max) nextIndex = 0;
      index = nextIndex;

      var gap = 20;
      try {
        gap = parseFloat(window.getComputedStyle(track).gap) || 20;
      } catch (e) {}
      var slideWidth = slides[0].getBoundingClientRect().width;
      var offset = index * (slideWidth + gap);
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';

      for (var i = 0; i < slides.length; i++) {
        var visible = i >= index && i < index + perView();
        slides[i].setAttribute('aria-hidden', visible ? 'false' : 'true');
      }

      for (var d = 0; d < dots.length; d++) {
        var on = d === index;
        dots[d].classList.toggle('is-active', on);
        dots[d].setAttribute('aria-current', on ? 'true' : 'false');
      }

      if (status) {
        status.textContent = String(index + 1) + '–' + String(Math.min(index + perView(), slides.length)) + ' / ' + String(slides.length);
      }

      var canAutoplay = autoplaySetting && max > 0 && !reduceMotion && !designMode;
      if (canAutoplay && !user) setBar(true);
      else if (user) setBar(canAutoplay && !hovering && !hidden);
      else setBar(false);
    }

    function stop() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
      setBar(false);
    }

    function play() {
      stop();
      var canAutoplay = autoplaySetting && maxIndex() > 0 && !reduceMotion && !designMode;
      if (!canAutoplay || hovering || hidden) return;
      setBar(true);
      timer = window.setTimeout(function () {
        show(index + 1, false);
        play();
      }, delay);
    }

    function go(nextIndex) {
      show(nextIndex, true);
      play();
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    root.addEventListener('mouseenter', function () {
      hovering = true;
      stop();
    });
    root.addEventListener('mouseleave', function () {
      hovering = false;
      play();
    });
    root.addEventListener('focusin', function () {
      hovering = true;
      stop();
    });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) {
        hovering = false;
        play();
      }
    });

    document.addEventListener('visibilitychange', function () {
      hidden = document.hidden;
      if (hidden) stop();
      else play();
    });

    var touchX = null;
    root.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      touchX = event.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (touchX == null || !event.changedTouches || !event.changedTouches[0]) return;
      var dx = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 40) return;
      go(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    function onResize() {
      updateChrome();
      buildDots();
      show(Math.min(index, maxIndex()), true);
      play();
    }

    if (mqTablet.addEventListener) {
      mqTablet.addEventListener('change', onResize);
      mqMobile.addEventListener('change', onResize);
    } else if (mqTablet.addListener) {
      mqTablet.addListener(onResize);
      mqMobile.addListener(onResize);
    }

    updateChrome();
    buildDots();
    show(0, false);
    play();
  }

  function boot() {
    toArray(document.querySelectorAll('[data-rv]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-rv]')).forEach(function (el) {
      el.removeAttribute('data-rv-ready');
      init(el);
    });
  });
})();
